import React from "react";
import { AlertTriangle } from "lucide-react";

// Anti-offline-deal notice. Copy is verbatim per user's Feb 2026 spec.
export default function AntiOfflineNotice({ tone = "info", className = "" }) {
  const base = "rounded-lg border p-3 flex items-start gap-2 text-xs leading-relaxed";
  const styles = tone === "warn"
    ? "border-[#C85A32]/40 bg-[#F0EBE1] text-[#1A1F2C]"
    : "border-[#2B3A67]/25 bg-[#D4DEC6]/25 text-[#1A1F2C]";
  return (
    <div className={`${base} ${styles} ${className}`} data-testid="anti-offline-notice">
      <AlertTriangle size={14} className="mt-0.5 text-[#C85A32] shrink-0" />
      <span>
        <strong className="font-semibold">Complete your deal through LocaNest.</strong>{" "}
        Deals done offline will lower your rating and visibility — without a good rating, you won&apos;t get preferred client access on this platform.
      </span>
    </div>
  );
}
